'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _Object$assign = require('babel-runtime/core-js/object/assign')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactBootstrap = require('react-bootstrap');

var _ClosableTab = require('./ClosableTab');

var _ClosableTab2 = _interopRequireDefault(_ClosableTab);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reduxModulesTabs = require('../redux/modules/tabs');

var actions = _interopRequireWildcard(_reduxModulesTabs);

var _reactContextmenu = require("react-contextmenu");

var _components = {
	_$TabFormContextMenu: {
		displayName: 'TabFormContextMenu'
	},
	_$TabListContextMenu: {
		displayName: 'TabListContextMenu'
	},
	_$TabbablePage: {
		displayName: 'TabbablePage'
	},
	_$Unknown: {
		isInFunction: true
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var TabFormContextMenu = (function (_React$Component) {
	_inherits(TabFormContextMenu, _React$Component);

	function TabFormContextMenu() {
		_classCallCheck(this, _TabFormContextMenu);

		_React$Component.apply(this, arguments);
	}

	TabFormContextMenu.prototype.render = function render() {
		var _this = this;

		return _react2['default'].createElement(
			_reactContextmenu.ContextMenu,
			{ identifier: 'TabFormContextMenu', currentItem: this.currentItem },
			_react2['default'].createElement(
				_reactContextmenu.MenuItem,
				{ data: { close: 1 }, onSelect: function (data) {
						return _this.handleSelect(data);
					} },
				'Zavřít'
			),
			_react2['default'].createElement(
				_reactContextmenu.MenuItem,
				{ data: { close: 2 }, onSelect: function (data) {
						return _this.handleSelect(data);
					} },
				'Zavřít ostatní'
			),
			_react2['default'].createElement(
				_reactContextmenu.MenuItem,
				{ data: { close: 3 }, onSelect: function (data) {
						return _this.handleSelect(data);
					} },
				'Zavřít vše'
			)
		);
	};

	TabFormContextMenu.prototype.handleSelect = function handleSelect(data) {
		this.props.onSelect(data);
	};

	var _TabFormContextMenu = TabFormContextMenu;
	TabFormContextMenu = _wrapComponent('_$TabFormContextMenu')(TabFormContextMenu) || TabFormContextMenu;
	return TabFormContextMenu;
})(_react2['default'].Component);

var TabListContextMenu = (function (_React$Component2) {
	_inherits(TabListContextMenu, _React$Component2);

	function TabListContextMenu() {
		_classCallCheck(this, _TabListContextMenu);

		_React$Component2.apply(this, arguments);
	}

	TabListContextMenu.prototype.render = function render() {
		var _this2 = this;

		return _react2['default'].createElement(
			_reactContextmenu.ContextMenu,
			{ identifier: 'TabListContextMenu', currentItem: this.currentItem },
			_react2['default'].createElement(
				_reactContextmenu.MenuItem,
				{ data: { close: 3 }, onSelect: function (data) {
						return _this2.handleSelect(data);
					} },
				'Zavřít ostatní'
			)
		);
	};

	TabListContextMenu.prototype.handleSelect = function handleSelect(data) {
		this.props.onSelect(data);
	};

	var _TabListContextMenu = TabListContextMenu;
	TabListContextMenu = _wrapComponent('_$TabListContextMenu')(TabListContextMenu) || TabListContextMenu;
	return TabListContextMenu;
})(_react2['default'].Component);

var TabbablePage = (function (_React$Component3) {
	_inherits(TabbablePage, _React$Component3);

	function TabbablePage() {
		_classCallCheck(this, _TabbablePage);

		_React$Component3.apply(this, arguments);
	}

	TabbablePage.prototype.componentDidMount = function componentDidMount() {
		if (this.props.tabs.length == 0) {
			if (this.props.params.id) {
				if (parseInt(this.props.params.id) == 0) {
					this.handleNewTab();
				} else {
					this.props.actions.openTabForm(this.props.module, '...', { id: parseInt(this.props.params.id) });
				}
			}
		}
		if (typeof this.props.params.id === 'undefined' && this.props.selectedTab !== 0 && this.context.location.query && this.context.location.query.filter) {
			this.props.actions.selectTab(this.props.module, 0);
		}
	};

	TabbablePage.prototype.handleSelectTab = function handleSelectTab(key) {
		if (key == 'add') {
			this.handleNewTab();
		} else {
			var tab = this.props.tabs.filter(function (item) {
				return item.id == key;
			})[0];
			this.props.actions.selectTab(this.props.module, key);
		}
	};

	TabbablePage.prototype.handleNewTab = function handleNewTab() {
		var args = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

		var data = { id: 0, unsave: true };
		if (args) {
			_Object$assign(data, args);
		}
		this.props.actions.openTabForm(this.props.module, this.props.newTitle, data);
	};

	TabbablePage.prototype.handleSelectContextMenu = function handleSelectContextMenu(data) {
		if (data.close == 1) {
			this.props.actions.closeTab(this.props.module, data.id);
		}
		if (data.close == 2) {
			this.props.actions.closeOthersTab(this.props.module, data.id);
		}
		if (data.close == 3) {
			this.props.actions.closeAll(this.props.module);
		}
		if (data.reload) {
			this.refs['tab' + data.id].getWrappedInstance().load();
		}
	};

	TabbablePage.prototype.handleCloseTab = function handleCloseTab(id) {
		this.props.actions.closeTab(this.props.module, id);
	};

	TabbablePage.prototype.render = function render() {
		var _this3 = this;

		var cmlayer = _reactContextmenu.ContextMenuLayer("TabFormContextMenu", function (props) {
			return {
				id: props.id
			};
		});
		var cmlayer0 = _reactContextmenu.ContextMenuLayer("TabListContextMenu", function (props) {
			return {};
		});
		var TabMenu = cmlayer0(_wrapComponent('_$Unknown')(_react2['default'].createClass({
			render: function render() {
				return _react2['default'].createElement(
					'div',
					null,
					this.props.title
				);
			}
		})));

		var ClosableTabMenu = cmlayer(_ClosableTab2['default']);

		/*const TabMenu = (React.createClass({
  	render() {
  		return <div>{this.props.title}</div>
  	}
  }));*/

		var tabs = this.props.tabs.map(function (item) {
			var title = _react2['default'].createElement(ClosableTabMenu, {
				onClose: function (key) {
					return _this3.props.actions.closeTab(_this3.props.module, key);
				},
				id: item.id,
				title: item.title,
				unsave: item.unsave
			});

			return _react2['default'].createElement(
				_reactBootstrap.Tab,
				{ key: item.id, eventKey: item.id, title: title },
				_react2['default'].createElement(_this3.props.Form, {
					tabid: item.id,
					ref: 'tab' + item.id,
					id: item.data,
					tab: item,
					tabActions: _this3.props.actions,
					closeTab: function () {
						return _this3.handleCloseTab(item.id);
					},
					updateTab: function (tab) {
						return _this3.props.actions.updateTab(_this3.props.module, item.id, tab);
					}
				})
			);
		});

		return _react2['default'].createElement(
			'div',
			{ className: 'tdidocument tabbable tab-content-bordered' },
			_react2['default'].createElement(TabFormContextMenu, { onSelect: function (data) {
					return _this3.handleSelectContextMenu(data);
				} }),
			_react2['default'].createElement(TabListContextMenu, { onSelect: function (data) {
					return _this3.handleSelectContextMenu(data);
				} }),
			_react2['default'].createElement(
				_reactBootstrap.Tabs,
				{ onSelect: function (key) {
						return _this3.handleSelectTab(key);
					},
					activeKey: this.props.selectedTab,
					animation: false },
				_react2['default'].createElement(
					_reactBootstrap.Tab,
					{ eventKey: 0, title: _react2['default'].createElement(TabMenu, { title: this.props.listTitle }) },
					_react2['default'].createElement(this.props.List, { module: this.props.module,
						actions: this.props.actions,
						onNewTab: function (args) {
							return _this3.handleNewTab(args);
						} })
				),
				tabs,
				!this.props.disableAdd && _react2['default'].createElement(_reactBootstrap.Tab, { eventKey: 'add',
					title: _react2['default'].createElement(TabMenu, { title: _react2['default'].createElement(
							'span',
							null,
							_react2['default'].createElement('span', { className: 'icon-plus3', style: { fontSize: 12 } }),
							' ',
							_react2['default'].createElement(
								'span',
								{ className: 'show-phone' },
								'přidat'
							)
						) }) })
			)
		);
	};

	_createClass(TabbablePage, null, [{
		key: 'contextTypes',
		value: {
			history: _react2['default'].PropTypes.object,
			location: _react2['default'].PropTypes.object
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			newTitle: 'Nový',
			listTitle: 'Seznam',
			disableAdd: false
		},
		enumerable: true
	}]);

	var _TabbablePage = TabbablePage;
	TabbablePage = _wrapComponent('_$TabbablePage')(TabbablePage) || TabbablePage;
	TabbablePage = _reactRedux.connect(function (state, props) {
		return {
			tabs: state.tabs[props.module].tabs,
			selectedTab: state.tabs[props.module].selected
		};
	}, function (dispatch) {
		return { actions: _redux.bindActionCreators(actions, dispatch) };
	})(TabbablePage) || TabbablePage;
	return TabbablePage;
})(_react2['default'].Component);

exports['default'] = TabbablePage;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/TabbablePage.js
 ** module id = 106
 ** module chunks = 2
 **/